import { UploadFile } from 'components/form/UploadFile';
import { ConfirmationModal } from 'components/modals/ConfirmationModal';
import { func_url } from 'functions';
import React, { useState } from 'react';
import { billingPortalBaseUrl } from "dataflow/billingPortal/constants";
import { useBillingSetupExcelImport } from './useBillingSetupExcelImport';


export function useBillingUpload(props) {
    const {
        importMassBillingSetup_requesting, 
        importMassBillingSetup_errorMsg, 
        importMassBillingSetup_status,
    } = props;
    
    const [isModalVisible_billingUpload, setIsModalVisible_billingUpload] = useState(false);

    const {
        uploadedFileName,
        isAlertMsgVisible: isAlertMsgVisible_billingUpload,

        alertMsg: alertMsg_billingUpload,
        alertMsgType: alertMsgType_billingUpload,

        onChange_uploadedFile,
        onClick_clearUploads,
        importFiles,

        inputUniqueId
    } = useBillingSetupExcelImport({
        importMassBillingSetup_requesting,
        importMassBillingSetup: props.importMassBillingSetup,
        importMassBillingSetup_errorMsg, 
        importMassBillingSetup_status,
    });
    
    let billingUploadModal = (
        <ConfirmationModal
            className={"recursiveBillingSetup-billingUpload"}
            description={"Choose file to upload"}

            headerClassName={"recursiveBillingSetup-billingUpload-header"}

            input={(
                <React.Fragment>
                    <UploadFile
                        className={"recursiveBillingSetup-billingUpload-input"}
                        acceptFileTypes={["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"]}
                        uploadedFileName={uploadedFileName}
                        
                        inputId={inputUniqueId}

                        label={"File"}
                        helperMsg={"*The file must be in .xlsx extension. All data must be in the first sheet of the file."}

                        onChange={onChange_uploadedFile}
                        onClick={onClick_clearUploads}
                    />

                    {/* Messages */}
                    {isAlertMsgVisible_billingUpload? (
                        <div className="recursiveBillingSetup-billingUpload-messages">
                            <div className="recursiveBillingSetup-billingUpload-label">
                                {(alertMsgType_billingUpload == "error")? "Error(s)":"Warning(s)"} Found:
                            </div>
                            <div className={"recursiveBillingSetup-billingUpload-link " +
                                    ((alertMsgType_billingUpload == "warning")? "recursiveBillingSetup-billingUpload-link_warningColor ":"") +
                                    ((alertMsgType_billingUpload == "error")? "recursiveBillingSetup-billingUpload-link_failureColor ":"")}
                                onClick={() => {
                                    func_url.saveAndOpenInNewTab(
                                        [
                                            {
                                                name: "billingSetup_invalidExcelFileMsg",
                                                value: alertMsg_billingUpload
                                            },
                                            {
                                                name: "billingSetup_invalidExcelFileType",
                                                value: alertMsgType_billingUpload 
                                            }
                                        ],
                                        billingPortalBaseUrl + "dashboard/recursiveBillingSetup/billingUploadInvalidMessages"
                                    );
                                }}
                            >
                                View in New Tab
                            </div>
                        </div>
                    ):""}
                </React.Fragment>
            )}
            
            cancelButtonText={"Cancel"}
            confirmButtonText={"Confirm"}
            isModalVisible={isModalVisible_billingUpload}
            updateParentState={setIsModalVisible_billingUpload}
            handleOnConfirm={importFiles}
            isActionLoading={importMassBillingSetup_requesting}
            isConfirmSuccessful={importMassBillingSetup_status}
        />
    );
    return {
        billingUploadModal,
        setIsModalVisible_billingUpload
    }
}